import React from "react";
import { Modal, useMediaQuery } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import * as Yup from "yup";
import { useFormik } from "formik";
import apiList from "../../api/apiList";
import { postRequest } from "../../api/apiServices";
import Toast from "../../utils/Toast";
import "../../styles/dialog-premium.css";

interface NeedInfoProps {
  open: boolean;
  onClose: () => void;
  email: String;
}

const NeedInfo: React.FC<NeedInfoProps> = ({ open, onClose, email }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  const formik = useFormik({
    initialValues: {
      information: "",
    },
    validationSchema: Yup.object({
      information: Yup.string().required("Information Required"),
    }),
    onSubmit: async (value) => {
      const response = await postRequest(apiList.candidatesNeedMoreInfoEmail, {
        email: email,
        content: value.information,
      });
      Toast(response?.data?.statusMessage);
      onClose();
    },
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="premium-modal-root"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      aria-labelledby="need-info-title"
    >
      <div
        className={`premium-modal-panel ${isMobile ? "" : "premium-modal-panel--wide"}`}
      >
        <div className="premium-dialog-header">
          <h2 id="need-info-title" className="premium-dialog-title">
            Request More Information
          </h2>
          <button
            type="button"
            className="premium-dialog-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseRoundedIcon sx={{ fontSize: 18 }} />
          </button>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <div className="premium-dialog-body">
            <label htmlFor="information" className="premium-dialog-label">
              What information do you need from the candidate?
            </label>
            <textarea
              id="information"
              name="information"
              className="premium-dialog-textarea"
              rows={isMobile ? 6 : 10}
              value={formik.values.information}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="e.g. Career website, video introduction, full vacancy details, scheduling a coffee chat..."
            />
            {formik.touched.information && formik.errors.information && (
              <div className="premium-dialog-error">
                {formik.errors.information}
              </div>
            )}
          </div>

          <div className="premium-dialog-footer">
            <button
              type="button"
              className="premium-dialog-btn premium-dialog-btn--cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="premium-dialog-btn premium-dialog-btn--confirm"
            >
              Send Request
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NeedInfo;
